import { Button, Title } from '@gerdau/hefesto';
import React, { useState } from 'react';
import { IResponsibleOfConstruction } from '../../../../../store/ducks/fabrication-contracts/types';
import { ConstructionRegistrationResumeBlock } from '../styles';
import { Container } from './styles';
import Table from '../../../../../components/Table';

interface IResponsibleOfConstructionResumeProps {
  responsiblesOfConstruction: IResponsibleOfConstruction[];
  onEditClick: () => void;
}

interface IResponsibleItemTableDataSource extends IResponsibleOfConstruction {
  key: number;
}

const ResponsibleOfConstructionResume: React.FC<
  IResponsibleOfConstructionResumeProps
> = ({ responsiblesOfConstruction, onEditClick }) => {
  const getDataTable = (): IResponsibleItemTableDataSource[] => {
    const dataTable: IResponsibleItemTableDataSource[] = [];

    responsiblesOfConstruction.forEach((responsible, idx) => {
      dataTable.push({
        key: idx,
        name: `${responsible.name}` || ' - ',
        email: `${responsible.email}` || ' - ',
        phoneNumber: `${responsible.phoneNumber}` || ' - ',
        jobTitle: `${responsible.jobTitle}` || ' - '
      });
    });
    return dataTable;
  };

  const renderTableCell = (text: string) => <span>{text || ' - '}</span>;

  const getColumns = () => [
    {
      title: 'Nome completo',
      dataIndex: 'name',
      render: (text: string) => renderTableCell(text)
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      render: (text: string) => renderTableCell(text)
    },
    {
      title: 'Telefone ou celular',
      dataIndex: 'phoneNumber',
      render: (text: string) => renderTableCell(text)
    },
    {
      title: 'Cargo',
      dataIndex: 'jobTitle',
      render: (text: string) => renderTableCell(text)
    }
  ];

  const [responsiblesData] = useState<IResponsibleItemTableDataSource[]>(
    getDataTable()
  );
  return (
    <Container>
      <ConstructionRegistrationResumeBlock>
        <header>
          <Title level={2}>Responsáveis pela obra</Title>
          <Button name="edit" variant="secondary" onClick={onEditClick}>
            Editar
          </Button>
        </header>
      </ConstructionRegistrationResumeBlock>

      <div className="table-container">
        <Table columns={getColumns()} data={responsiblesData} />
      </div>

      <ConstructionRegistrationResumeBlock />
    </Container>
  );
};

export default ResponsibleOfConstructionResume;
